import type { ViewKind } from '@/domain/constants';

/**
 * Where a view OPENS - the one destination table for a saved view, shared by
 * the nav rail and by every page that lists views (the group page's span
 * section). A board opens its board page on every layout (`/boards/<id>`, the
 * retired `/lists/<id>` answering a redirect there), a lens its lens surface.
 * Saved MAP views retired into lenses (docs/LENSES.md §6/S5), so they land
 * there too. The retired `list` kind names no row any more and opens as a
 * board.
 */
export function viewHref(kind: ViewKind, id: string): string {
  if (kind === 'board' || kind === 'list') return `/boards/${id}`;
  return `/views/${id}`;
}
